import React from "react";
import { Formik, Form } from "formik";
import LdsButton from "../components/LdsButton";
import LdsLink from "../components/LdsLink";

import { useForgotPasswordMutation } from "../store/services/authServerApi";
import LdsValidationError from "../components/LdsValidationError";
import LdsTextField from "../components/LdsTextField";
import { BootstrapAlert } from "../components/BootstrapAlert";

// validation schema
import { ForgotPasswordSchema } from "../validationSchema/ForgotPasswordSchema";

const Password = () => {
  const [
    forgotPassword,
    {
      isLoading,
      error: { data: { message: errorMessage } = {} } = {},
      data: { message: successMessage } = {},
    },
  ] = useForgotPasswordMutation();
  console.log(
    "isLoading, errorMessage, successMessage :>> ",
    isLoading,
    errorMessage,
    successMessage
  );

  const handleSubmit = ({ email }, { resetForm }) => {
    forgotPassword(btoa(email));
  };

  return (
    <>
      <main className="section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-sm-12 col-md-6">
              <h1 className="blue text-uppercase b text-center">
                Forgot password
                {!successMessage && "?"}
              </h1>
              <p className="text-center mt-4">
                {!successMessage ? (
                  `Please enter the email address associated with your account and
                we will send your password.`
                ) : (
                  <BootstrapAlert variant="success" message={successMessage} />
                )}
              </p>
            </div>
          </div>
          <div className="row justify-content-center mt-4">
            <div className="col-sm-12 col-md-4">
              <BootstrapAlert variant="danger" message={errorMessage} />
              {!successMessage && (
                <Formik
                  initialValues={{
                    email: "",
                  }}
                  validationSchema={ForgotPasswordSchema}
                  onSubmit={handleSubmit}
                >
                  {({ handleChange, errors, touched }) => (
                    <Form>
                      <div className="row">
                        <div className="col">
                          <LdsTextField
                            maxLength={100}
                            onChange={handleChange}
                            label="Email Address"
                            labelRequired
                            name="email"
                            id="email"
                            type="email"
                            error={errors.email && touched.email}
                          />
                          {errors.email && touched.email && (
                            <LdsValidationError id="erremail">
                              {errors.email}
                            </LdsValidationError>
                          )}

                          <div className="col-sm-12 col-md-6 offset-md-3">
                            <LdsButton
                              classes="blue-button mt-3 d-block mx-auto"
                              type="submit"
                              disabled={isLoading}
                            >
                              Submit
                            </LdsButton>
                          </div>
                        </div>
                      </div>
                    </Form>
                  )}
                </Formik>
              )}

              <div className="row">
                <div className="col-sm-12 col-md-6 offset-md-3">
                  <LdsLink
                    href="/login"
                    useIcon
                    icon="arrow-left"
                    iconOnly
                    contextualIcon
                    iconLabel="My Account"
                    iconPosition="before"
                    className="mt-5 d-block orange text-center"
                  >
                    Back to login
                  </LdsLink>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default Password;
